enum SCORES {
	GET_SCORES = '/api/scores',
	// SCORE_REASONS = '/api/scores/reasons',
	SCORE_REASONS = '/api/settings/dictionary/scoreReasons',
	SCORE_STUDENTS_BALANCE = '/api/scores/balance/',
	SCORE_STUDENTS_GPA = '/api/scores/gpa/',
	TRIGGER_AUTO_YEARLY_BONUSES = '/api/scores/auto/yearly-bonuses',
	APPROVE_SCORE = '/api/scores/',
	REJECT_SCORE = '/api/scores/',
	EXPORT = '/api/scores/export'
}

enum SCORE_REQUESTS {
	SCORE_REQUESTS = '/api/score-requests',
	EXPORT = '/api/score-requests/export'
}

enum BENEFITS {
	BENEFITS = '/api/benefits',
	EXPORT = '/api/benefits/export'
}

enum BENEFIT_APPLICATIONS {
	BENEFIT_APPLICATIONS = '/api/benefit-applications',
	EXPORT = '/api/benefit-applications/export'
}

enum QR_VERIFY {
	QR_VERIFY = '/api/qr-verify',
	QR_SCAN_HISTORY = '/api/qr-verify/logs'
}

export default {
	SCORES,
	SCORE_REQUESTS,
	BENEFITS,
	BENEFIT_APPLICATIONS,
	QR_VERIFY
};
